import React from 'react';
import { Pagination, Card } from 'antd';
import styled from 'styled-components';
import { useTranslation } from '../../../../../i18n/useTranslation';

const PaginationContainer = styled(Card)`
    padding: 8px;
    .ant-pagination {
        display: flex;
        align-items: center;

        .ant-pagination-total-text {
            order: 1;
            margin: 0;
            flex-grow: 1;
            text-align: right;
        }

        .ant-pagination-options {
            order: -1;
            margin: 0;
            flex-grow: 1;
        }
    }
`;

interface Props {
    page: number;
    pageSize: number;
    loading?: boolean;
    totalCount: number;
    className?: string;
    onShowSizeChange: any;
    showSizeChanger?: boolean;
    pageSizeOptions?: number[];
    onChangePage: (page: number) => void;
    showLessItems?: boolean;
}

export const PaginationBar = ({
    page,
    loading,
    pageSize,
    className,
    totalCount,
    onChangePage,
    onShowSizeChange,
    pageSizeOptions = [10, 20, 30],
    showSizeChanger = true, // default to true
    showLessItems = false,
}: Props) => {
    const { t } = useTranslation();
    return (
        <PaginationContainer className={className}>
            <Pagination
                current={page}
                total={totalCount}
                disabled={loading}
                pageSize={pageSize}
                showQuickJumper={false}
                onChange={onChangePage}
                className="f-pagination-bar"
                showLessItems={showLessItems}
                pageSizeOptions={pageSizeOptions}
                showSizeChanger={showSizeChanger || false}
                onShowSizeChange={(_currNum, newNum) => onShowSizeChange(newNum)}
                showTotal={(total, range) => `${range[0]}-${range[1]} ${t('of')} ${total} ${t('items')}`}
                locale={{ items_per_page: `/ ${t('page')}` }}
            />
        </PaginationContainer>
    );
};
